export default {
    data() {
        return {
            saveClose: false
        }
    },
    methods: {
        saveAndClose: function(){
            this.saveClose = true;
            this.submitForm();
        },
        save: function(){
            this.saveClose = false;
            this.submitForm();
        },
        view: function(){
            if (this.prefix){
                this.$router.push('/' + this.prefix + '/'+ this.resource + '/' + this.item.id + '/view').then();
            } else {
                this.$router.push('/'+ this.resource + '/' + this.item.id + '/view').then();
            }
        },
        cancel: function () {
            this.$router.push(this.return).then();
        },
    }
}
